import { create } from "zustand";

interface MixboardState {
  session: any;
  layers: any[];
  references: any[];
  typographyAssets: any[];
  selectedLayerId: string | null;
  loading: boolean;
  autosaving: boolean;
  styleControls: Record<string, any>;
  setSession: (session: any | ((prev: any) => any)) => void;
  setLayers: (layers: any[] | ((prev: any[]) => any[])) => void;
  setReferences: (refs: any[]) => void;
  setTypographyAssets: (assets: any[]) => void;
  setSelectedLayerId: (id: string | null) => void;
  setAutosaving: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  setStyle: (style: Record<string, any>) => void;
  updateLayer: (id: string, patch: Record<string, any>) => void;
  addLayer: (layer: any) => void;
}

export const useMixboard = create<MixboardState>((set, get) => ({
  session: null,
  layers: [],
  references: [],
  typographyAssets: [],
  selectedLayerId: null,
  loading: false,
  autosaving: false,
  styleControls: {},

  setSession: (session) =>
    set((state) => ({ session: typeof session === "function" ? session(state.session) : session })),
  setLayers: (layers) =>
    set((state) => ({ layers: typeof layers === "function" ? layers(state.layers) : layers })),
  setReferences: (refs) => set({ references: refs }),
  setTypographyAssets: (assets) => set({ typographyAssets: assets ?? [] }),
  setSelectedLayerId: (id) => set({ selectedLayerId: id }),
  setAutosaving: (value) => set({ autosaving: value }),
  setLoading: (value) => set({ loading: value }),
  setStyle: (style) => set({ styleControls: style ?? {} }),

  updateLayer: (id, patch) => {
    const layers = get().layers.map((layer) => (layer.id === id ? { ...layer, ...patch } : layer));
    set({ layers });
  },

  addLayer: (layer) => set({ layers: [...get().layers, layer] }),
}));
